import { Button, Key, Text } from '@bbl-digital/snorre'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SEND_EMAIL_UPDATE_RECIPIENTS_REQUESTED } from 'shared/store/sendMessage/email/actionTypes'
import { handleRecipientModal } from 'shared/store/sendMessage/recipients'
import {
  getFrequentRecipients,
  getFrequentRecipientsSearch,
} from 'shared/store/sendMessage/recipients/selectors'
import { SEND_SMS_UPDATE_RECIPIENTS_REQUESTED } from 'shared/store/sendMessage/sms/actionTypes'
import { IMessageRecipient, RecipientTypeEnum } from '../../models/Inbox'
import {
  IFrequentRecipientsModel,
  MessageTypeEnum,
  RecipientOpenState,
} from '../../models/Recipients'
import MostFrequentRecipientsLoading from './MostFrequentRecipientsLoading'
import { FrequentItem, FrequentList, Wrapper, RecipientWrapper } from './styles'

interface IProps {
  type: MessageTypeEnum
  search: string
  recipientType?: RecipientTypeEnum
  resetSearch?: () => void
}

const MostFrequentRecipientsModal = React.forwardRef<HTMLDivElement, IProps>(
  (
    { type, search = '', recipientType = RecipientTypeEnum.To, resetSearch },
    ref
  ) => {
    const [open, setOpen] = useState(true)
    const { sms, email } = useSelector(getFrequentRecipients)
    const filtered = useSelector(
      getFrequentRecipientsSearch({ search, type, recipientType })
    )

    const dispatch = useDispatch()

    const isEmail = type === MessageTypeEnum.Email
    const loading = email.loading || sms.loading

    const openType: RecipientOpenState = isEmail ? 'Email' : 'SMS'

    const handleAddFrequent = (item: IFrequentRecipientsModel) => {
      const payload: Partial<IMessageRecipient> = {
        email: item.email,
        name: item.name,
        nameregisterId: item.nameId,
        phonenumber: item.phonenumber,
        recipientType: recipientType,
      }

      const type = isEmail
        ? SEND_EMAIL_UPDATE_RECIPIENTS_REQUESTED
        : SEND_SMS_UPDATE_RECIPIENTS_REQUESTED

      dispatch({
        type,
        payload,
      })

      setOpen(false)
      resetSearch?.()
    }

    const handleOpenRecipientModal = () => {
      dispatch(handleRecipientModal({ open: openType, type: recipientType }))

      setOpen(false)
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (e.key === Key.escape) setOpen(false)
    }

    useEffect(() => {
      return () => {
        setOpen(false)
      }
    }, [])

    if (!open) return null

    return (
      <Wrapper tabIndex={0} ref={ref} onKeyDown={handleKeyDown}>
        <Button onClick={handleOpenRecipientModal}>Finn mottaker</Button>

        <RecipientWrapper>
          <Text semibold size="16px">
            Mest brukte mottakere
          </Text>

          <FrequentList>
            {loading ? (
              <MostFrequentRecipientsLoading />
            ) : filtered.length ? (
              filtered.map((frequent) => {
                const name = isEmail ? frequent.email : frequent.phonenumber

                return (
                  <FrequentItem
                    key={frequent.nameId || frequent.name || name}
                    onClick={() => handleAddFrequent(frequent)}
                  >
                    <Text semibold>{frequent.name || name}</Text>
                    {frequent.name && <Text>{name}</Text>}
                  </FrequentItem>
                )
              })
            ) : (
              <Text>{search ? 'Ingen treff' : 'Ditt søk ga ingen treff'}</Text>
            )}
          </FrequentList>
        </RecipientWrapper>
      </Wrapper>
    )
  }
)

export default MostFrequentRecipientsModal
